const depths = {
  toc: 100,
  documentFooter: 110,
  editorToolbar: 750,
  header: 800,
  sidebar: 900,
  mobileSidebar: 930,
  hoverPreview: 950,
  // Note: editor lightbox is z-index 999
  overlay: 2000,
  modal: 3000,
  menu: 4000,
  toasts: 5000,
  popover: 9000,
  titleBarDivider: 10000,
  loadingIndicatorBar: 20000,
  commandBar: 30000,
  presentation: 40000,
  tooltip: 50000,
};

export default depths;
